export default "__VITE_ASSET__E49TKj6k__"